import { url, windowHelper } from '@tencent/ppd-base-libs';
/**
 * 小巴商户ID
 */
const HKLB_MERCHANT_ID = 'CX-1750992794513';
/**
 * 小巴商户品牌页链接
 */
const HKLB_CHANNEL_URL = 'https://prom.wechatpay.com.hk/merchant-channel/index.shtml?spId=HKLB&actType=springAct&eCashCp=1&ADTAG=HKLBoffline';
/**
 * 处理扫码小巴活动特殊跳转
 https://tapd.woa.com/tapd_fe/10145891/story/detail/1010145891125700040
 *  */
export const isHKLBSpecialRedirect = () => {
  const merchantId = url.getUrlParam('merchantId');
  return HKLB_MERCHANT_ID === merchantId;
};

export const redirectToHKLBChannelPage = () => {
  windowHelper.redirect(HKLB_CHANNEL_URL);
};
